import * as React from 'react';
import {LOAN_APPLICATION_MX, SUMMARY_MX} from '../../../../constants/LabelConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {SummaryStepProps} from '../../../../types/mx/creditoReal/components';
import {pushDataLayer} from '../../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../../common/constants/LabelConstants';
import Button from '../../../../../common/components/Button';

class SummaryStepView extends React.Component<SummaryStepProps, {}> {

    constructor(props) {
        super(props);
        this.props.getLoanApplicationSummary();
    }

    static defaultProps = {
        references: []
    };

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
            pushDataLayer(DATA_LAYER.FINISHED);
        }, 200);
    }

    renderSubtitleWithEditButton = (step, title) => {
        return (
            <div className="col-12 d-flex justify-content-between header-bar mb-3">
                <div className="d-flex justify-content-start align-items-center">{title}</div>
            </div>
        );
    }

    componentWillUnmount() {
        this.props.closeMarketingModal();
    }

    renderItemRow = (key, value) => {
        return (
            value &&
            <div className="row">
                {this.renderKey(key)}
                {this.renderValue(value)}
            </div>
        );
    }

    renderKey = (text) => {
        return (
            <div className="col-4 text-right">
                <p className="text-secondary-lighten-4">{text}</p>
            </div>
        );
    }

    renderValue = (text) => {
        return (
            <div className="col-8">
                <p className="text-secondary-lighten-1">{text}</p>
            </div>
        );
    }

    renderCreditConditions = () => {
        const {desiredVehicle, price, entry, state, amountFinance, term, monthlyPayment} = this.props;
        return (
            <React.Fragment>
                {this.renderSubtitleWithEditButton(1, SUMMARY_MX.CREDIT_CONDITIONS)}
                {this.renderItemRow(SUMMARY_MX.VEHICLE, desiredVehicle)}
                {this.renderItemRow(SUMMARY_MX.PRICE, price)}
                {this.renderItemRow(SUMMARY_MX.DOWN_PAYMENT, entry)}
                {this.renderItemRow(SUMMARY_MX.STATE, state)}
                {this.renderItemRow(SUMMARY_MX.AMOUNT_FINANCE, amountFinance)}
                {this.renderItemRow(SUMMARY_MX.TERM, term)}
                {this.renderItemRow(SUMMARY_MX.MONTHLY_PAYMENTS, monthlyPayment)}
            </React.Fragment>
        );
    }

    renderApplicantDate = () => {
        const {completeName, birthDate, rfc, cellPhone, email} = this.props;
        return (
            <React.Fragment>
                {this.renderSubtitleWithEditButton(2, SUMMARY_MX.APPLICANT_DATA)}
                {this.renderItemRow(SUMMARY_MX.COMPLETE_NAME, completeName)}
                {this.renderItemRow(SUMMARY_MX.BIRTH_DATE, birthDate)}
                {this.renderItemRow(SUMMARY_MX.RFC, rfc)}
                {this.renderItemRow(SUMMARY_MX.CELL_PHONE, cellPhone)}
                {this.renderItemRow(SUMMARY_MX.EMAIL, email)}
            </React.Fragment>
        );
    }

    renderActualHome = () => {
        const {
            homeAddress, homeExtNumber, homeIntNumber, homePostalCode, homeState, homeCity, homeMunicipality,
            homeColony, homePhone
        } = this.props;
        return (
            <React.Fragment>
                {this.renderSubtitleWithEditButton(3, SUMMARY_MX.ACTUAL_HOME)}
                {this.renderItemRow(SUMMARY_MX.ADDRESS, homeAddress)}
                {this.renderItemRow(SUMMARY_MX.NRO_EXT, homeExtNumber)}
                {this.renderItemRow(SUMMARY_MX.NRO_INT, homeIntNumber)}
                {this.renderItemRow(SUMMARY_MX.POSTAL_CODE, homePostalCode)}
                {this.renderItemRow(SUMMARY_MX.STATE, homeState)}
                {this.renderItemRow(SUMMARY_MX.CITY, homeCity)}
                {this.renderItemRow(SUMMARY_MX.MUNICIPALITY, homeMunicipality)}
                {this.renderItemRow(SUMMARY_MX.COLONY, homeColony)}
                {this.renderItemRow(SUMMARY_MX.PHONE_WITH_LADA, homePhone)}
            </React.Fragment>
        );
    }

    renderJobInfo = () => {
        const {
            workplaceName, workplacePosition, workplaceSince, workplaceAddress, workplaceExtNumber,
            workplaceIntNumber, workplacePostalCode, workplaceState, workplaceCity, workplaceMunicipality,
            workplaceColony, workplacePhone, workplacePhoneExt, workplaceMonthlyIncomes
        } = this.props;
        return (
            <React.Fragment>
                {this.renderSubtitleWithEditButton(4, SUMMARY_MX.WORK_INFO)}
                {this.renderItemRow(SUMMARY_MX.WORKPLACE, workplaceName)}
                {this.renderItemRow(SUMMARY_MX.POSITION, workplacePosition)}
                {this.renderItemRow(SUMMARY_MX.WORKING_SINCE, workplaceSince)}
                {this.renderItemRow(SUMMARY_MX.ADDRESS, workplaceAddress)}
                {this.renderItemRow(SUMMARY_MX.NRO_EXT, workplaceExtNumber)}
                {this.renderItemRow(SUMMARY_MX.NRO_INT, workplaceIntNumber)}
                {this.renderItemRow(SUMMARY_MX.POSTAL_CODE, workplacePostalCode)}
                {this.renderItemRow(SUMMARY_MX.STATE, workplaceState)}
                {this.renderItemRow(SUMMARY_MX.CITY, workplaceCity)}
                {this.renderItemRow(SUMMARY_MX.MUNICIPALITY, workplaceMunicipality)}
                {this.renderItemRow(SUMMARY_MX.COLONY, workplaceColony)}
                {this.renderItemRow(SUMMARY_MX.PHONE_NUMBER, workplacePhone)}
                {this.renderItemRow(SUMMARY_MX.EXTENSION, workplacePhoneExt)}
                {this.renderItemRow(SUMMARY_MX.MONTHLY_INCOME, workplaceMonthlyIncomes)}
            </React.Fragment>
        );
    }

    renderReferences = () => {
        const {references} = this.props;
        if (references.length > 0) {
            return (
                <React.Fragment>
                    {this.renderSubtitleWithEditButton(5, SUMMARY_MX.REFERENCES)}
                    {references.map((reference, index) => {
                        return (
                            <div key={index} className="row">
                                {this.renderKey(`${reference.firstName} ${reference.lastName} ${reference.secondLastName}`)}
                                {this.renderValue(reference.phone)}
                            </div>
                        );
                    })}
                </React.Fragment>
            );
        }
    }

    renderInsurance = () => {
        const {insurancePaymentType, insuranceName, insuranceAmount} = this.props;
        return (
            <React.Fragment>
                {this.renderSubtitleWithEditButton(6, SUMMARY_MX.INSURANCE)}
                {this.renderItemRow(SUMMARY_MX.INSURANCE_PAYMENT, insurancePaymentType)}
                {insuranceName && this.renderItemRow(SUMMARY_MX.INSURANCE_CARRIER, insuranceName)}
                {insuranceAmount && this.renderItemRow(SUMMARY_MX.ANNUAL_INSURANCE, insuranceAmount)}
            </React.Fragment>
        );

    }

    render() {
        const {name, desiredVehicle, price} = this.props;

        return (
            <div className="col-md-8 offset-md-2">
                <div className="row mb-5 mt-4">
                    <div className="col text-center">
                        <img src={AssetsManager('/assets/images/common/success-icon.svg')}/>
                    </div>
                </div>
                <div className="row mb-3 mt-3">
                    <div className="col text-center">
                        <h3 className="text-raleway text-secondary-lighten-1">
                            {LOAN_APPLICATION_MX.FINISHED_TITLE}
                        </h3>
                    </div>
                </div>
                <div className="row p-none mb-2">
                    <div className="col text-left">
                        {LOAN_APPLICATION_MX.FINISHED_CONGRATULATIONS.replace('$name', name)
                            .replace('$vehicle', desiredVehicle).replace('$price', price)}
                    </div>
                </div>
                <div className="row p-none mb-2">
                    <div className="col text-left">
                        {LOAN_APPLICATION_MX.FINISHED_CONTACT_1}
                    </div>
                </div>
                <div className="row p-none mb-2">
                    <div className="col text-left">
                        {LOAN_APPLICATION_MX.FINISHED_CONTACT_2_LONG_TEXT}
                    </div>
                </div>
                <div className="row p-none mb-4">
                    <div className="col text-left">
                        {LOAN_APPLICATION_MX.FINISHED_MESSAGE}
                    </div>
                </div>
                {this.renderCreditConditions()}
                {this.renderApplicantDate()}
                {this.renderActualHome()}
                {this.renderJobInfo()}
                {this.renderReferences()}
                {this.renderInsurance()}
                <div className="col d-flex justify-content-center">
                    <Button onPress={this.props.onPressGotoHome} text={LOAN_APPLICATION_MX.GOTO_HOME}
                            customClass="px-5 mb-4"/>
                </div>
            </div>
        );
    }
}

export default SummaryStepView;